import { FC } from "react";

import { Button } from "antd";

import eyeIcon from "data/icons/eye.svg";
import downloadIcon from "data/icons/downloads-white.svg";
import filetypeLink from "data/icons/filetype_link.svg";

import "./FileHolder.scss";

interface IProps {
  file: string;
  file_type?: string;
  original_file_name: string;
}

const FileHolder: FC<IProps> = ({ file, original_file_name }) => {

  const onDownload = () => {
    fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([ blob ]));
        const link = document.createElement("a");
        link.href = url;
        link.download = original_file_name || "downloaded-file";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error fetching the file:", error);
      });
  }

  return (
    <div className="file-holder-wrapper">
      <div className="file-holder">
        <img
          alt=""
          className="file-holder-icon"
          src={ filetypeLink }
        />

        <div className="black-back">
          <a
            href={ file }
            rel="noreferrer"
            target="_blank"
          >
            <Button
              type="primary"
              icon={ <img src={ eyeIcon } alt="" /> }
            />
          </a>

          <Button
            type="primary"
            icon={ <img src={ downloadIcon } alt="" /> }
            onClick={ onDownload }
          />
        </div>
      </div>

      <p className="description">
        { original_file_name }
      </p>
    </div>
  )
}

export default FileHolder;
